// Schema.org JSON-LD Structured Data Generator

export const getLocalBusinessSchema = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  return {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    '@id': `${siteUrl}/#organization`,
    'name': '湧水堂',
    'description': '船橋市高根台の水回りリフォーム専門店。ユニットバス、キッチン、トイレ、洗面所の施工実績6,812件、Google口コミ★4.7。',
    'url': siteUrl,
    'telephone': '+81-47-401-0700',
    'email': 'info@yusuidou.com',
    'priceRange': '$$',
    'image': `${siteUrl}/logo.png`,
    'address': {
      '@type': 'PostalAddress',
      'streetAddress': '高根台1-13-1-102',
      'addressLocality': '船橋市',
      'addressRegion': '千葉県',
      'postalCode': '274-0065',
      'addressCountry': 'JP'
    },
    'geo': {
      '@type': 'GeoCoordinates',
      'latitude': '35.7236',
      'longitude': '140.0425'
    },
    'openingHoursSpecification': [
      {
        '@type': 'OpeningHoursSpecification',
        'dayOfWeek': ['Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        'opens': '10:00',
        'closes': '19:00'
      }
    ],
    'aggregateRating': {
      '@type': 'AggregateRating',
      'ratingValue': '4.7',
      'reviewCount': '156',
      'bestRating': '5',
      'worstRating': '1'
    },
    'areaServed': {
      '@type': 'City',
      'name': '船橋市',
      'containedInPlace': {
        '@type': 'State',
        'name': '千葉県'
      }
    },
    'hasOfferCatalog': {
      '@type': 'OfferCatalog',
      'name': '水回りリフォームサービス',
      'itemListElement': [
        {
          '@type': 'Offer',
          'itemOffered': {
            '@type': 'Service',
            'name': 'ユニットバスリフォーム',
            'description': 'ユニットバスの交換・リフォーム工事'
          }
        },
        {
          '@type': 'Offer',
          'itemOffered': {
            '@type': 'Service',
            'name': 'キッチンリフォーム',
            'description': 'システムキッチンの交換・リフォーム工事'
          }
        },
        {
          '@type': 'Offer',
          'itemOffered': {
            '@type': 'Service',
            'name': 'トイレリフォーム',
            'description': 'トイレの交換・リフォーム工事'
          }
        },
        {
          '@type': 'Offer',
          'itemOffered': {
            '@type': 'Service',
            'name': '洗面所リフォーム',
            'description': '洗面台の交換・リフォーム工事'
          }
        }
      ]
    },
    'sameAs': [
      'https://www.facebook.com/yusuidou',
      'https://www.instagram.com/yusuidou',
      'https://line.me/R/ti/p/@yusuidou'
    ]
  };
};

export const getWebSiteSchema = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    '@id': `${siteUrl}/#website`,
    'url': siteUrl,
    'name': '湧水堂 - 船橋市水回りリフォーム専門店',
    'description': '船橋市高根台の水回りリフォーム専門店。施工実績6,812件、Google口コミ★4.7。',
    'publisher': {
      '@id': `${siteUrl}/#organization`
    },
    'inLanguage': 'ja-JP'
  };
};

export const getWebPageSchema = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  return {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    '@id': `${siteUrl}/#webpage`,
    'url': siteUrl,
    'name': '船橋市水回りリフォーム専門店｜ユニットバス・キッチン・トイレ工事｜湧水堂',
    'isPartOf': {
      '@id': `${siteUrl}/#website`
    },
    'about': {
      '@id': `${siteUrl}/#organization`
    },
    'description': '船橋市高根台の水回りリフォーム専門店・湧水堂。ユニットバス・キッチン・トイレ・洗面所の施工実績6,812件、Google口コミ★4.7。',
    'inLanguage': 'ja-JP'
  };
};

export const getBreadcrumbSchema = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    'itemListElement': [
      {
        '@type': 'ListItem',
        'position': 1,
        'name': 'ホーム',
        'item': siteUrl
      }
    ]
  };
};

export const getFAQSchema = () => {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    'mainEntity': [
      {
        '@type': 'Question',
        'name': '船橋市でのユニットバスリフォームの費用はいくらですか？',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': 'ユニットバスリフォームの費用は、浴槽のサイズや仕様によって異なりますが、一般的に80万円〜150万円程度です。無料で現場調査を行い、お客様のご予算に合わせた最適なプランをご提案いたします。'
        }
      },
      {
        '@type': 'Question',
        'name': '工事期間はどのくらいかかりますか？',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': 'ユニットバスリフォームの場合、通常3〜5日程度です。キッチンやトイレのリフォームは内容により1〜3日程度です。工事前に詳しいスケジュールをご説明いたします。'
        }
      },
      {
        '@type': 'Question',
        'name': '船橋市のどの地域に対応していますか？',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': '船橋市全域に対応しております。旭町、海神、高根台、習志野台など、船橋市内であればどちらでも対応可能です。まずはお気軽にご相談ください。'
        }
      },
      {
        '@type': 'Question',
        'name': '見積もりは無料ですか？',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': 'はい、現場調査・お見積もりは完全無料です。お電話（047-401-0700）またはLINEにてお気軽にお問い合わせください。無理な営業は一切いたしません。'
        }
      }
    ]
  };
};

export const getOrganizationSchema = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    '@id': `${siteUrl}/#organization`,
    'name': '湧水堂',
    'url': siteUrl,
    'logo': `${siteUrl}/logo.png`,
    'contactPoint': {
      '@type': 'ContactPoint',
      'telephone': '+81-47-401-0700',
      'contactType': 'customer service',
      'email': 'info@yusuidou.com',
      'areaServed': 'JP',
      'availableLanguage': 'Japanese',
      'hoursAvailable': {
        '@type': 'OpeningHoursSpecification',
        'dayOfWeek': ['Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        'opens': '10:00',
        'closes': '19:00'
      }
    }
  };
};

// Inject all structured data into the page
export const injectStructuredData = () => {
  const schemas = [
    getLocalBusinessSchema(),
    getWebSiteSchema(),
    getWebPageSchema(),
    getBreadcrumbSchema(),
    getFAQSchema(),
    getOrganizationSchema()
  ];

  schemas.forEach((schema, index) => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = `structured-data-${index}`;
    script.text = JSON.stringify(schema);
    document.head.appendChild(script);
  });
};
